import { render, staticRenderFns } from "./ProductTypeForm.vue?vue&type=template&id=97b4110c&scoped=true&"
import script from "./ProductTypeForm.vue?vue&type=script&lang=js&"
export * from "./ProductTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypeForm.vue?vue&type=style&index=0&id=97b4110c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b4110c",
  null
  
)

export default component.exports